import styled from 'styled-components';
import { Drawer, withStyles } from '@material-ui/core';
import SVGIcon from '../../SVGIcon';
import Button from '../../BuildingBlocks/Button';
import { colors, media, mixins } from '../../css';

const { pxToRem } = mixins;

export const StyledDrawer = withStyles({
  modal: {
    zIndex: 50,
    right: 'auto'
  },
  paper: {
    width: '25%',
    boxShadow:
      '0px 8px 10px -5px rgba(0, 0, 0, 0.1), 0px 16px 24px 2px rgba(0, 0, 0, 0.07), 0px 6px 30px 5px rgba(0, 0, 0, 0.06)',
    overflowY: 'visible',
    zIndex: 50
  }
})(Drawer);

export const StyledSVGIcon = styled(SVGIcon).attrs({
  iconColor: colors.colorGrey,
  selectedIcon: 'arrow'
})`
  transform: rotate(${({ open }) => (open ? 90 : 270)}deg);
  transition: transform 250ms ease-in-out;
`;

export const DrawerContainer = styled.div`
  position: absolute;
  width: 100%;
  background-color: ${colors.colorWhite};
  left: 0;
  top: 0;
  height: 100%;

  ${media.lessThan('md')`
    height: ${pxToRem(60)};
    bottom: 0;
    top: auto;
    width: 100%;

    .ll-map-mobile-panel-body {
      padding-left: 0px;
      padding-right: 0px;
    }
  `};
`;

export const DrawerContent = styled.div`
  background-color: ${colors.colorWhite};
  width: 100%;
  padding: ${pxToRem(80)} 0px 0px;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  ${media.lessThan('md')`
    width: 100%;
    padding-top: 0;
    padding-bottom: 60px;
    position: absolute;
  `};

  ${({ contentStyleOverrides }) => contentStyleOverrides};
`;

export const DrawerButtonDesktop = styled(Button).attrs({
  className: 'drawer-button',
  size: 'lg',
  theme: 'white'
})`
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${pxToRem(50)};
  height: ${pxToRem(100)};
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  position: absolute;
  z-index: 10;
  bottom: ${pxToRem(30)};
  left: ${({ open }) => (open ? '100%' : 'calc(100% + 35px)')};
`;

export const DrawerButtonMobile = styled(Button)`
  padding: 0 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: absolute;
  height: 100%;
  box-shadow: 0px 0px 30px 10px ${colors.colorBurgundyRgba(0.1)};
`;

export const DrawerButtonMobileContent = styled.div`
  display: flex;
  align-items: center;

  img {
    width: ${({ imgWidth }) => imgWidth};
    height: ${({ imgHeight }) => imgHeight};
    display: inline;
    margin-right: ${pxToRem(20)};
  }
`;
